/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ERC165Upgradeable__factory } from "./ERC165Upgradeable__factory";
export { IERC165Upgradeable__factory } from "./IERC165Upgradeable__factory";
